import React, { useEffect, useState } from "react";
import RestaurantContractText from "./RestaurantContractText";
import { getRestaurantContractReceipts } from "../../services/supabase/restaurantContractService";
import { buildRestaurantContractCopy, downloadRestaurantContractCopy } from "../../services/local/restaurantContract";
import "../../styles/RestaurantContract.css";

export default function RestaurantContractReceipts({ companyId }) {
  const [state, setState] = useState({ loading: true, receipts: [], error: "" });
  const [attempt, setAttempt] = useState(0);
  const [downloading, setDownloading] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, receipts: [], error: "" });
    if (!companyId) { setState({ loading: false, receipts: [], error: "" }); return undefined; }
    getRestaurantContractReceipts(companyId).then((receipts) => {
      if (!cancelled) setState({ loading: false, receipts, error: "" });
    }).catch((error) => {
      if (!cancelled) setState({ loading: false, receipts: [], error: error.message });
    });
    return () => { cancelled = true; };
  }, [companyId, attempt]);
  const download = async (receipt) => {
    setDownloading(true);
    try { await downloadRestaurantContractCopy(receipt); }
    catch { setState((current) => ({ ...current, error: "No pudimos descargar la copia. Reintenta." })); }
    finally { setDownloading(false); }
  };
  return <section className="restaurant-contract" aria-labelledby="restaurant-contract-copies">
    <h2 id="restaurant-contract-copies">Contrato del restaurante</h2>
    {state.loading && <p role="status">Cargando contrato...</p>}
    {state.error && <div role="alert">{state.error} <button type="button" onClick={() => setAttempt((n) => n + 1)}>Reintentar</button></div>}
    {!state.loading && !state.error && state.receipts.length === 0 && <p>No hay una aceptacion registrada para esta empresa.</p>}
    {state.receipts.map((receipt) => <div key={receipt.id}>
      <p>Version {receipt.version} / Aceptado el {new Date(receipt.acceptedAt).toLocaleString("es-AR", { timeZone: "America/Argentina/Buenos_Aires" })} (Argentina)</p>
      <details><summary>Ver contrato y constancia</summary>
        <RestaurantContractText text={buildRestaurantContractCopy(receipt)} label="Contrato y constancia aceptados" />
      </details>
      <button type="button" disabled={downloading} onClick={() => download(receipt)}>Descargar copia PDF</button>
      {receipt.deliveryStatus === "sent" ? <p>Copia enviada a {receipt.actorEmail}.</p> : <p>La copia esta disponible aqui. El envio por correo esta pendiente.</p>}
    </div>)}
  </section>;
}
